import React, { useEffect, useState } from "react";
import './Dashboard.css';
import apiClient from "../../axios";
import moment from "moment";


function Dashboard() {
    const [dashboardData, setDashboardData] = useState({
        leadCount: 0,
        clickCount: 0,
        goodLeadCount: 0,
        payment: 0,
    });
    useEffect(() => {
        // Fetch dashboard data with the configured Axios instance
        apiClient.get('/affiliate/course/details')
            .then((response) => {
                const result = response.data; // Axios automatically parses JSON
                setDashboardData({
                    leadCount: result?.data.leadCount || 0,
                    clickCount: result.data.clickCount || 0,
                    goodLeadCount: result.data.goodLeadCount || 0,
                    payment: result.data.userAmount || 0,
                });
            })
            .catch((error) => {
                console.error('Error fetching dashboard data:', error);
            });
    }, []);
    const user_name = sessionStorage.getItem('user_name')
    const currentDate = moment().format("MMMM D YYYY"); 
    return (
        <>
            <div className="dashboard">
                <div className="card afff" style={{ width: "100%", maxWidth: "none" }}>
                    <div>
                        <div className="text-start">
                            <small style={{ color: "white" }}>{currentDate}</small>
                            <div style={{ bottom: "0", position: "absolute", marginBottom: "50px", color: "white" }}>
                                <h4>Welcome Back {user_name}</h4>
                                <small>Always stay Updated with Leadsense portal</small>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="enq">
                    <div className="d-flex">
                        {/* Approved Leads Card */}
                        <div className="card" style={{ width: "24%", height: "200px", marginRight: "15px", padding: "20px" }}>
                            <h3>Leads</h3>
                            <h2 className="h2tag">{dashboardData.leadCount}</h2>
                        </div>

                        {/* Rejected Leads Card */}
                        <div className="card" style={{ width: "24%", height: "200px", marginRight: "15px", padding: "20px" }}>
                            <h3>Clicks</h3>
                            <h2 className="h2tag">{dashboardData.clickCount}</h2>
                        </div>

                        {/* Total Leads Card */}
                        <div className="card" style={{ width: "24%", height: "200px", marginRight: "15px", padding: "20px" }}>
                            <h3>Converted Leads</h3>
                            <h2 className="h2tag">{dashboardData.goodLeadCount}</h2>
                        </div>

                        {/* Payment Card */}
                        <div className="card" style={{ width: "24%", height: "200px", padding: "20px" }}>
                            <h3>Payment</h3>
                            <h2 className="h2taginr">INR {dashboardData.payment}</h2>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Dashboard;